window.addEventListener('DOMContentLoaded', function() {
  const sticky = document.getElementById('product--sticky');
  const mobileSticky = document.getElementById('product--sticky__mobile');
  if (sticky && mobileSticky) {
    const mainSection = document.querySelector('.shopify-section--main-product buy-buttons');
    if (mainSection) {
      if (mainSection.getBoundingClientRect().bottom > 0 && mainSection.getBoundingClientRect().top < window.innerHeight) {
        mobileSticky.classList.remove('active')
      } else {
        mobileSticky.classList.add('active')
      }
      if (mainSection.getBoundingClientRect().bottom > 0) {
        sticky.classList.remove('active');
      } else {
        sticky.classList.add('active');
      }

      window.addEventListener('scroll', function() {
        if (mainSection.getBoundingClientRect().bottom > 0 && mainSection.getBoundingClientRect().top < window.innerHeight) {
          mobileSticky.classList.remove('active')
        } else {
          mobileSticky.classList.add('active')
        }
        if (mainSection.getBoundingClientRect().bottom > 0) {
          sticky.classList.remove('active');
        } else {
          sticky.classList.add('active');
        }
      });
    }
  }

  document.querySelector('.header__primary-nav button[aria-controls="sidebar-menu"]').addEventListener('click', function(){
    var element = document.documentElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  })

  const mobileMenuBtn = document.querySelector('x-header button[aria-controls="sidebar-menu"]');
  
  mobileMenuBtn.addEventListener('click', function(){
    document.querySelector('#sidebar-menu .header-sidebar__linklist li button[aria-expanded="true"]').click();
  }, { once: true });
});